export default __webpack_public_path__ + "static/media/React.5929148e.png";